import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="text-sm">
      <ol className="flex items-center flex-wrap gap-1.5 text-muted-foreground">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-accent">
            <Home className="h-3.5 w-3.5" /> Home
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={i} className="inline-flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5" />
            {it.href && i < items.length - 1 ? (
              <Link to={it.href} className="hover:text-accent">{it.label}</Link>
            ) : (
              <span className="text-primary font-semibold">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
